// Events can arrive out of order, so a snapshot sent before a logout may land after it.
// Snapshots at or before the logout time are stale until the agent logs in again.
const loggedOutAt = new Map<string, number>();
// Time of the last login or logout applied per agent, to reject older ones that arrive late.
const lastLifecycleAt = new Map<string, number>();

function toMs(timestamp: string): number | null {
  const ms = Date.parse(timestamp);
  return Number.isNaN(ms) ? null : ms;
}

function isOlderThanLastLifecycle(agentId: string, ms: number) {
  const last = lastLifecycleAt.get(agentId);
  return last !== undefined && ms < last;
}

/** Returns false when the logout is older than a login or logout already applied. */
export function recordAgentLoggedOut(agentId: string, timestamp: string) {
  const ms = toMs(timestamp);
  if (ms === null) {
    return true;
  }
  if (isOlderThanLastLifecycle(agentId, ms)) {
    return false;
  }
  lastLifecycleAt.set(agentId, ms);
  loggedOutAt.set(agentId, ms);
  return true;
}

/** Returns false when the login is older than a login or logout already applied. */
export function recordAgentLoggedIn(agentId: string, timestamp: string) {
  const ms = toMs(timestamp);
  if (ms === null) {
    return true;
  }
  if (isOlderThanLastLifecycle(agentId, ms)) {
    return false;
  }
  lastLifecycleAt.set(agentId, ms);
  loggedOutAt.delete(agentId);
  return true;
}

export function isStaleAfterLogout(agentId: string, timestamp: string) {
  const logoutMs = loggedOutAt.get(agentId);
  if (logoutMs === undefined) {
    return false;
  }
  const ms = toMs(timestamp);
  return ms !== null && ms <= logoutMs;
}

export function resetAgentLogoutGuard() {
  loggedOutAt.clear();
  lastLifecycleAt.clear();
}
